import { createAction } from '@reduxjs/toolkit';
import { deliverableState } from 'store/states/deliverableState';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const changePageSize = createAction(BaselineAffectationType.ChangePageSize, (newPageSize: number) => ({
  payload: { newPageSize },
}));
export const changePage = createAction(BaselineAffectationType.ChangePage, (newPage: number) => ({
  payload: { newPage },
}));

export const changeTotalItems = createAction(BaselineAffectationType.ChangeTotalItems, (totalItems: number) => ({
  payload: { totalItems },
}));

export const changeTotalPages = createAction(BaselineAffectationType.ChangeTotalPages, (totalPages: number) => ({
  payload: { totalPages },
}));
export const injectBaselineAffectation = createAction(
  BaselineAffectationType.Inject,
  (baseLineOrderWorkunits: OrderWorkunit[], totalItems: number, totalPages: number, currentPage: number) => ({
    payload: { baseLineOrderWorkunits, totalItems, totalPages, currentPage },
  })
);

export default (state = deliverableState, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.Inject:
      return {
        ...state,
        baseLineOrderWorkunits: action.payload.baseLineOrderWorkunits,
        totalItems: action.payload.totalItems,
        totalPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
      };
    case BaselineAffectationType.LoadDeliverable:
      return {
        ...state,
        deliverables: [],
        totalItems: 0,
        totalPages: 0,
        currentPage: 0,
      };
    default:
      return state;
  }
};
